import { render, staticRenderFns } from "./widgetTable.vue?vue&type=template&id=7606f232&scoped=true&"
import script from "./widgetTable.vue?vue&type=script&lang=js&"
export * from "./widgetTable.vue?vue&type=script&lang=js&"
import style0 from "./widgetTable.vue?vue&type=style&index=0&id=7606f232&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7606f232",
  null
  
)

export default component.exports